// Charge la base commune
// import bundle from './form.module.js' // lazy-loading code splitting (se charge uniquement en cas de call lazy-loading like)
// import _ from 'lodash' // lazy-loading dynamic import (se charge uniquement en cas de call lazy-loading like)

// Styles librairies
// import './js/libs/malihu-custom-scrollbar-plugin-master/jquery.mCustomScrollbar.css'

// Styles custom
import './scss/pages/blog'

// Scripts librairies
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'
import './js/libs/paginate/jquery.paginate.min.js'

require('./common.js')

// rafraîchissement
function r () {
  Waypoint.refreshAll()
}

// OwlCarousel
function getOwlCarousel () {
  import('./js/components/owl-carousel.js').then(() => {
    r()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des carousel
  const $f = $('div.owl-carousel')
  if ($f.length) {
    $f.waypoint(function () {
      getOwlCarousel()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // jquery pajinate
  const _container = $('div.pajinate')
  _container.each(function () {
    const _t = $(this)
    const _perPage = _t.attr('data-pajinante-items-per-page') || 5
    const _numLinks = _t.attr('data-pajinante-num-links') || 5
    _t.pajinate({
      items_per_page: parseInt(_perPage),
      num_page_links_to_display: parseInt(_numLinks),
      item_container_id: _t.attr('data-pajinate-container') || '.pajinate-container',
      nav_panel_id: '.pajinate-nav ul',
      show_first_last: true,
      wrap_around: true,
      abort_on_small_lists: true,
      start_page: 0,
      nav_label_prev: '<i class="inh icon-angle-left"></i>',
      nav_label_next: '<i class="inh icon-angle-right"></i>',
      nav_label_first: '<i class="inh icon-angle-double-left"></i>',
      nav_label_last: '<i class="inh icon-angle-double-right"></i>'
    })
  })

  if ($('#go').length) {
    const t = $('#go')
    $('html, body').animate({
      scrollTop: ($(t).offset().top - $('#pageTop').height() - 50)
    }, 500)
  }
})
